<template>
	<div class="cabin-cut">
		<table class="table booking-table text-[15px]">
			<thead>
				<tr>
					<th class="cabin">舱房</th>
					<th class="sale-prices">同行价</th>
					<th class="sug-sale-prices">建议零售价</th>
					<th class="room-num">
						房间数
						<el-tooltip content="默认按照最低入住成人计算" placement="top">
							<i class="tip-icon ficon ficon-wenhao"></i>
						</el-tooltip>
					</th>
					<th class="total">
						<el-button type="default" size="small" v-if="hasAlliance" @click="handleShowCabin">库存明细</el-button>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="stock in expandTable" :key="stock.id">
					<td class="cabin">
						<div class="cabin-img overflow-hidden">
							<el-image class="cabin-img-inner" fit="cover" :src="stock.cabin.images"
								@click="showCanbinDetailWithDialog(stock)" />
						</div>
						<div class="cabin-content">
							<h3 class="cabin-title text-secondary flex cursor-pointer transition-colors hover:text-primary" @click="showCanbinDetailWithDialog(stock)" >
                <div>{{ stock.cabin_name }}</div>
                <i class="el-icon-arrow-right ml-1"></i>
              </h3>
							<p class="cabin-detail">
								{{ stock.cabin.room_area }}
								<v-divider direction="vertical" />
								{{ stock | peopleStr }}
								<br />
								{{
									stock.cabin.window_label
								}}<template v-if="stock.cabin.window_area">({{ stock.cabin.window_area }})</template>
								<v-divider direction="vertical" />{{
									stock.cabin.floor_label.join(",")
								}}层
							</p>
						</div>
					</td>
					<td class="sale-prices">
						<el-popover popper-class="border border-warn" trigger="hover" :visible-arrow="false">
							<div slot="reference">
								<template v-if="cruiseType === 1">
									<p v-if="stock.prices.th.adult_price" class="price whitespace-nowrap leading-6">
										￥{{ stock.prices.th.adult_price }}/成人
									</p>
									<p v-if="stock.prices.th.child_price" class="price whitespace-nowrap leading-6">
										￥{{ stock.prices.th.child_price }}/儿童
									</p>
								</template>
								<template v-else>
									<p v-if="stock.prices.th.adult_price" class="price whitespace-nowrap leading-6">
										￥{{ stock.prices.th.adult_price }}/第1/2人
									</p>
									<p v-if="stock.prices.th.adult34_price" class="price whitespace-nowrap leading-6">
										￥{{ stock.prices.th.adult34_price }}/第3/4成人
									</p>
									<p v-if="stock.prices.th.child34_price" class="price whitespace-nowrap leading-6">
										￥{{ stock.prices.th.child34_price }}/第3/4儿童
									</p>
								</template>
							</div>

							<!-- <template #popover> -->
							<TablePriceTip :data="stock.prices.th" />
							<!-- </template> -->
						</el-popover>
					</td>
					<td class="sug-sale-prices">
						<el-popover popper-class="border border-warn" trigger="hover" :visible-arrow="false">
							<div slot="reference">
								<template v-if="cruiseType === 1">
									<p v-if="stock.prices.sale.adult_price" class="price whitespace-nowrap leading-6">
										￥{{ stock.prices.sale.adult_price }}/成人
									</p>
									<p v-if="stock.prices.sale.child_price" class="price whitespace-nowrap leading-6">
										￥{{ stock.prices.sale.child_price }}/儿童
									</p>
								</template>
								<template v-else>
									<p v-if="stock.prices.sale.adult_price" class="price whitespace-nowrap leading-6">
										￥{{ stock.prices.sale.adult_price }}/第1/2人
									</p>
									<p v-if="stock.prices.sale.adult34_price" class="price whitespace-nowrap leading-6">
										￥{{ stock.prices.sale.adult34_price }}/第3/4成人
									</p>
									<p v-if="stock.prices.sale.child34_price" class="price whitespace-nowrap leading-6">
										￥{{ stock.prices.sale.child34_price }}/第3/4儿童
									</p>
								</template>
							</div>
							<TablePriceTip :data="stock.prices.sale" />

						</el-popover>
					</td>
					<td class="room-num">
						<div class="cell">
							<p class="room-num-text">{{ stock.last_stock | mapStockText }}</p>
							<el-input-number size="mini" v-model="stock.roomNum" :min="stock.minRoomNum"
								:step="stock.roomNumStep" />
							<p v-if="stock.messages">
								{{ stock.messages }}
							</p>
						</div>
					</td>
					<td class="total">
						<template v-if="stock.totalPrice > 0">
							<p class="total-prices">
								<span class="amount text-price">
									￥<span class="num">{{ stock.totalPrice }}</span>
								</span>
								<el-popover class="d-inline-block price-popover" popper-class="border border-warn" :container="false" :visible-arrow="false">
									<i slot="reference" class="tip-icon ficon ficon-tanhao" />
									<div class="price-wraper">
										<div class="price-header">
											总计：<span class="price-text !text-price">￥{{ stock.totalPrice }}</span>
											<span class="profit-text">利润：￥{{ stock.totalProfit }}</span>
										</div>
										<div class="price-table">
											<dl v-for="(priceRow, index) in stock.totalPriceList" :key="index"
												class="price-row">
												<dt class="price-row-label">{{ priceRow.title }}</dt>
												<dd class="nums">x {{ priceRow.num }}</dd>
												<dd class="!text-price font-medium">￥{{ priceRow.totalPrice }}</dd>
												<dd class="profit-text">
													利润：￥{{ priceRow.profit }}
												</dd>
											</dl>
										</div>
									</div>
								</el-popover>
								<br /><span class="profit-tag">利润：￥{{ stock.totalProfit }}</span>
							</p>
						</template>
						<p v-else class="total-prices-tip leading-5">请先在左侧<br />选择入住人数</p>
					</td>
				</tr>
			</tbody>
		</table>
		<!-- <el-button @click="isExpand = true">展开</el-button> -->
		<!-- <submit-bar
      :amount="totalAmount"
      :profit="totalProfit"
      :people-num="totalPeople"
      :room-num="totalRoom"
      @on-submit="handleSubmit"
    >
      <template #price-table>
        <div class="price-wraper">
          <div class="price-header">
            共{{ totalRoom }}间，总计：¥{{ totalAmount }} 利润：¥{{
              totalProfit
            }}
          </div>
          <div class="price-table">
            <dl v-for="row in totalPriceTable" :key="row.id" class="price-row">
              <dt class="price-row-label">{{ row.cabin_name }}</dt>
              <dd class="nums">{{ row.roomNum }}间</dd>
              <dd>
                ¥ {{ row.totalPrice }}，<span class="profit-color"
                  >利润 ¥ {{ row.totalProfit }}</span
                >
              </dd>
            </dl>
          </div>
        </div>
      </template>
    </submit-bar> -->
	</div>
</template>

<script>
import { InlandCut, OceanCut } from "./components/booking/index";
import TablePriceTip from "@/views/product/DetailBookingTablePriceTip";
// import Main from '@/components/ScrollActive';
// import { mapActions, mapState } from "vuex";
// import SubmitBar from "./DetailBookingSubmitBar";
import { floatAdd, sum } from "@/utils/helpers.js";
import { submitOrderBooking } from "@/services/order";
export default {
	name: "BookingCut",
	components: { TablePriceTip },
	filters: {
		peopleStr(stock) {
			return stock.min_people === stock.max_people
				? `必须入住${stock.min_people}人`
				: [stock.min_people, stock.max_people].join("-") + "人";
		},
		mapStockText(stock) {
			if (stock > 10) {
				return "库存充足";
			}
			if (stock > 0) {
				return `仅剩${stock}间`;
			}
			return "1小时内确认";
			// return stock > 10 ? "库存充足" : `仅剩${stock}间`;
		}
	},
	props: {
		defaultData: {
			type: Array,
			default: () => []
		},
		productNo: {
			type: String,
			default: ""
		},
		hasAlliance: Boolean,
		cruiseType: {
			type: [Number, String],
			default: 1
		},
		stockData: {
			type: Array,
			default: () => []
		},
		bookingType: String,
		currentVoyage: {
			type: Object,
			default: () => ({})
		},
		class_id: {
			type: String,
			default: "",
		}
	},
	data() {
		return {
			cabinTable: [],
			priceTable: [],
			isExpand: false
		};
	},
	computed: {
		// ...mapState("product/booking", [
		//   "stockData",
		//   "bookingType",
		//   "currentVoyage"
		// ]),
		expandTable() {
			return this.cabinTable;
		},
		totalPriceTable() {
			return this.priceTable.filter(row => row.roomNum > 0);
		},
		totalAmount() {
			// return sum(this.totalPriceTable.map(row => row.totalPrice));
			return this.totalPriceTable.reduce((sum, row) => floatAdd(sum, row.totalPrice), 0)
		},
		totalProfit() {
			// return sum(this.totalPriceTable.map(row => row.totalProfit));
			return this.totalPriceTable.reduce((sum, row) => floatAdd(sum, row.totalProfit), 0)
		},
		totalPeople() {
			return sum(
				this.totalPriceTable.map(row => sum([row.adultNum, row.childNum]))
			);
			// return  this.totalPriceTable.reduce((sum, row) => floatAdd(sum, floatAdd(row.adultNum, row.childNum)), 0);
		},
		totalRoom() {
			return this.totalPriceTable.reduce((sum, row) => floatAdd(sum, row.roomNum), 0)
			// return sum(this.totalPriceTable.map(row => row.roomNum));
		},
		emitValue() {
			return {
				amount: this.totalAmount,
				profit: this.totalProfit,
				'people-num': this.totalPeople,
				'room-num': this.totalRoom,
				totalPriceTable: this.totalPriceTable
			}
		},
	},
	watch: {
		stockData: {
			immediate: true,
			handler(stocks) {
				this.priceTable = stocks.map(stock => {
					let row =
						this.cruiseType == 1 ? new InlandCut(stock) : new OceanCut(stock);
					let defaultData = this.defaultData.find(
						item => item.class_id == row.class_id
					);

					if (!defaultData) return row;
					console.log({ defaultData, row }, row.class_id);
					Object.assign(row, {
						roomNum: defaultData.room_num,
						childNum: defaultData.child_num,
						adultNum: defaultData.adult_num,
						// _diffRoomNum: defaultData.diff_room_num,
						childBedNum: defaultData.child_bed_num
					});
					row.validate && row.validate();
					return row;
				});
				this.cabinTable = this.priceTable.filter(item => item.cabin_class_id === this.class_id);
			}
		},
		defaultData(values) {
			if (!this.priceTable.length) return;

			this.priceTable = this.priceTable.map(row => {
				let defaultData = values.find(item => item.class_id == row.class_id);

				if (!defaultData) return row;
				Object.assign(row, {
					roomNum: defaultData.room_num,
					childNum: defaultData.child_num,
					adultNum: defaultData.adult_num,
					childBedNum: defaultData.child_bed_num
				});
				row.validate && row.validate();
				return row;
			});
		},
		emitValue: {
			deep: true,
			handler: function (value) {
				this.$emit('input', value)
			}
		},
		class_id(values) {
			this.cabinTable = this.priceTable.filter(item => item.cabin_class_id === values);
		}
	},
	methods: {
		// ...mapActions("product/booking", ["submitOrderBooking"]),
		handleShowCabin() {
			this.$emit("onShowStock");
		},
		async submitOrderBooking(params) {
			let { code, data, msg } = await submitOrderBooking(params);
			if (code !== 10000) {
				return { code, msg };
			}
			return { code, data, msg };
		},
		async handleSubmit() {
			let cabins = this.priceTable
				.map(row => ({
					sps_id: row.id, //库存ID
					cabin_id: row.cabin_id, //舱房ID
					room_num: row.roomNum, //房间数
					amount: row.totalPrice, //总金额
					adult_num: row.adultNum, //成人数 切舱为0
					child_num: row.childNum, //儿童数 切舱为0
					diff_room_num: row.diffRoomNum, //单房差数 切舱为0
					child_bed_num: row.childBedNum //儿童加床数 切舱为0
				}))
				.filter(cabin => cabin.room_num > 0);

			let { code, data, msg } = await this.submitOrderBooking({
				product_no: this.productNo,
				date: this.currentVoyage.date,
				spd_id: this.currentVoyage.id,
				sale_type: 1,
				cabins
			});

			if (code !== 10000) {
				this.$message.error(msg);
				return;
			}

			this.$router.push({
				// path: "placeorder",
				name: "product-cruise-booking",
				query: {
					booking_no: data.booking_no
				}
			});
		},
		showCanbinDetailWithDialog(stockData) {
			const dialog = this.$createCabinDialog({
				$props: {
					data: stockData,
				},
			}).show()
		},
	}
};
</script>

<style lang="scss" scoped>

@import "./scss/booking-table.scss";

.booking-table {

	th,
	td {
		&.room-num {
			text-align: center;
		}
	}

	// table-layout: inherit;
}

.room-num {
	text-align: center;

	.cell {
		display: inline-block;
	}
}

</style>
